export class wwsUrlService {
    static baseUrl: string = process.env.VUE_APP_WWS_ADMIN;
    static logOutRedirect: string = process.env.VUE_APP_LOGOUT_REDIRECT;

    static loginPage() {
        return `${this.baseUrl}/DocumentEditor.aspx`
    }

    static homePage() {
        return `${this.baseUrl}`
    }

    static logOutUrl() {
        return `${this.baseUrl}/Login.aspx?command=apiLogout&ReturnUrl=${this.logOutRedirect}`
    }
}